jQuery(function($){
  $('[data-ref="video-modal-trigger"]').magnificPopup({
    type: 'iframe',
  });
});
